const LIMIT = 250;

function update(root) {
  const message = root.querySelector('[data-gift-message]');
  const count = root.querySelector('[data-gift-count]');
  if (message && count) count.textContent = `${LIMIT - message.value.length} characters left`;
  const form = root.dataset.form && document.getElementById(root.dataset.form);
  const card = root.querySelector('input[type="radio"]:checked');
  if (form) form.toggleAttribute('data-gift-card', Boolean(card && card.value));
}

document.addEventListener('click', (event) => {
  const zoom = event.target.closest('[data-card-zoom]');
  if (zoom) {
    const dialog = zoom.closest('[data-gift-options]').querySelector('[data-card-dialog]');
    const img = dialog.querySelector('[data-card-dialog-img]');
    img.src = zoom.dataset.cardZoom;
    img.alt = zoom.dataset.cardTitle + ' card';
    dialog.showModal();
  } else if (event.target.closest('[data-card-dialog-close]') || event.target.matches('[data-card-dialog]')) {
    event.target.closest('[data-card-dialog]').close();
  }
});

for (const type of ['input', 'change']) {
  document.addEventListener(type, (event) => {
    const root = event.target.closest('[data-gift-options]');
    if (root) update(root);
  });
}

window.addEventListener('pageshow', (event) => {
  if (event.persisted) document.querySelectorAll('[data-gift-options][data-busy]').forEach((root) => delete root.dataset.busy);
});

document.addEventListener('submit', async (event) => {
  const form = event.target;
  const formId = form.getAttribute('id');
  const root = formId && document.querySelector(`[data-gift-options][data-form="${CSS.escape(formId)}"]`);
  const card = root && root.querySelector('input[type="radio"]:checked');
  if (!card || !card.value) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (root.dataset.busy) return;
  root.dataset.busy = 'true';

  const data = new FormData(form);
  const id = Number(data.get('id'));
  const properties = {};
  for (const [key, value] of data) {
    const match = /^properties\[(.+)\]$/.exec(key);
    if (match && String(value).trim()) properties[match[1]] = String(value).trim();
  }
  const error = root.querySelector('[data-gift-error]');
  error.hidden = true;

  try {
    const response = await fetch(root.dataset.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          { id, quantity: Number(data.get('quantity')) || 1, properties },
          { id: Number(card.value), quantity: 1, parent_id: id },
        ],
      }),
    });
    if (response.ok) {
      window.location.href = root.dataset.cartUrl;
      return;
    }
    const body = await response.json().catch(() => ({}));
    error.textContent = body.description || 'Something went wrong. Please try again.';
  } catch (err) {
    error.textContent = 'We could not reach the shop. Please check your connection and try again.';
  }
  error.hidden = false;
  delete root.dataset.busy;
}, true);
